import React, { useState } from "react";
import TecTree from "../../assets/header/tec-tree.png";
import Logo from "../../assets/header/dante-dev.png";
import "./Header.css";

function Header() {
  const [isNavActive, setIsNavActive] = useState(false);

  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };

  return (
    <header className="header">
      <nav className={`nav ${isNavActive ? "active" : ""}`}>
        <a href="#home" className="logo">
          <img src={Logo} alt="Imagem logo do site 'DanteDev'"></img>
          <img
            src={TecTree}
            alt="Árvore tecnológica, logo secundária DanteDev"
          ></img>
        </a>
        <button className="hamburger" onClick={toggleNav}></button>
        <ul className="nav-list">
          <li>
            <a onClick={toggleNav} href="#home">
              Home
            </a>
          </li>
          <li>
            <a onClick={toggleNav} href="#bio">
              Bio
            </a>
          </li>
          <li>
            <a onClick={toggleNav} href="#experiencias">
              Experiências
            </a>
          </li>
          <li>
            <a
              onClick={toggleNav}
              href="https://www.linkedin.com/in/jovicarvalho/"
              target="_blank"
              rel="noreferrer"
            >
              Contato
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
